import * as React from "react";
import {Form, message, Input, Button} from "antd";
import {push} from "@netless/i18n-react-router";
import {observer} from "mobx-react";
import {RouteComponentProps, withRouter} from "react-router";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import LoginLayout from "../LoginLayout";
import {registerStore} from "../../models/RegisterStore";
import {consoleApi} from "../../apiMiddleware";


const FormItem = Form.Item;
export type RegisterProps = RouteComponentProps<{ tab: string }> & InjectedIntlProps;

export type LoginByPhoneStates = {
    confirmDirty: boolean;
};

@observer
class ResetPassword extends React.Component<RegisterProps, LoginByPhoneStates> {

    public constructor(props: RegisterProps) {
        super(props);
        this.state = {
            confirmDirty: false,
        };
    }

    private handleSubmit = async (values: any): Promise<void> => {
        const {intl} = this.props;
        const email = this.getQueryVariable("email");
        const code = this.getQueryVariable("code");
        try {
            if (email && code) {
                const res = await consoleApi.user.resetPassword(email, values.password, code);
                if (res.code === 200) {
                    push(this.props.history, "/login/");
                    message.success(intl.formatHTMLMessage({id: "global.update-success"}));
                } else {
                    message.error(intl.formatHTMLMessage({id: "global.update-fail"}));
                }
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    private getQueryVariable = (variable: string): string | null => {
        const query = window.location.search.substring(1);
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");
            if (pair[0] === variable) {return pair[1]; }
        }
        return null;
    }

    public render(): React.ReactNode {
        const {intl} = this.props;
        const email = this.getQueryVariable("email");
        return (
            <LoginLayout>
                <div style={{width: 296}}>
                    <div className="login-title">
                        <FormattedMessage
                            id={"global.update-password-title"}
                        />
                    </div>
                    {email && <div style={{marginBottom: 28}}>
                        <Input size="large" disabled value={email}/>
                    </div>}
                    <Form onFinish={this.handleSubmit} className="login-form">
                        <FormItem
                            name={"password"}
                            extra={<span style={{color: "gray", fontSize: 12}}>
                                <FormattedMessage
                                    id={"global.password-reset-tips"}
                                />
                            </span>}
                            rules={[
                                {required: true, message: intl.formatMessage({id: "global.please-new-password"})},
                                {pattern: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,21}$/, message: intl.formatMessage({id: "global.please-provide-message"})},
                            ]}
                        >
                            <Input.Password size="large" placeholder={intl.formatMessage({id: "global.please-new-password"})}/>
                        </FormItem>
                        <FormItem
                            name={"password-confirm"}
                            rules={[{required: true, message: intl.formatMessage({id: "global.input-new-password-again"})}]}
                        >
                            <Input.Password size="large" placeholder={intl.formatMessage({id: "global.input-new-password-again"})}/>
                        </FormItem>
                        <FormItem>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                loading={registerStore.registerLoadingState}
                                className="register-form-button">
                                <FormattedMessage
                                    id={"global.update-password"}
                                />
                            </Button>
                        </FormItem>
                    </Form>
                </div>
            </LoginLayout>
        );
    }
}

export default withRouter(injectIntl(ResetPassword));



// WEBPACK FOOTER //
// ./src/components/user/ResetPassword.tsx